'use client';

import styled, { css } from 'styled-components';
import { Timeline } from '@mantine/core';

import { colors, breakpoints } from '@/styles/theme';

export const Container = styled(Timeline)`
  display: flex;
  flex-direction: column;

  width: 100%;

  margin: 0 auto;
`;

export const ModuleWrap = styled(Timeline.Item)`
  display: flex;
  flex-direction: column;

  position: relative;
  transition: all 0.4s ease;
  box-shadow: none;

  .arrow {
    transition: all 0.4s ease;
  }

  border-radius: 0 22px 22px 0;
  padding: ${({ $compact }) => ($compact ? '0 32px 16px' : '0 32px 32px')};

  &:hover {
    box-shadow: 0px 12px 18px -6px rgb(0 0 0 / 10%);
  }

  ${({ $hasLink }) =>
    $hasLink
      ? css`
          &:hover {
            cursor: pointer;
            .arrow {
              transform: translateX(5px) scale(1.1);
            }
          }
        `
      : css`
          &:hover {
            cursor: default;
          }
        `};
`;

export const Module = styled.div`
  display: flex;
  flex-direction: column;

  gap: 6px;
`;

export const Number = styled.div`
  color: ${colors.light};
  font-size: 1.875rem;
  font-weight: 600;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 1.1rem;
`;

export const Description = styled.div`
  display: flex;

  margin-top: 10px;

  font-weight: 300;
  line-height: 1.2;
  text-align: justify;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.9rem;
  }
`;

export const Lecturer = styled.div`
  display: flex;
  align-items: center;

  gap: 5px;
`;

export const PortraitWrap = styled.div`
  width: 20px;
  height: 20px;

  overflow: hidden;
  border-radius: 50%;
`;

export const LecturerName = styled.div`
  font-size: 1rem;
  font-weight: 400;
`;

export const Icons = styled.div`
  display: flex;

  gap: 12px;
`;

export const Features = styled.div`
  display: flex;
  align-items: center;

  gap: 12px;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const EventTime = styled.div`
  display: flex;
  align-items: center;

  color: ${colors.gray5};
`;

export const Time = styled.div`
  margin-left: 5px;
`;

export const Tags = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  gap: 6px;
`;

export const TitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
